export { SegmentedControls } from './segmented-controls';
export { SegmentedControl } from './segmented-control';
//# sourceMappingURL=index.js.map